import { render } from "./SecondPart.vue?vue&type=template&id=d2c80b4e&scoped=true"
import script from "./SecondPart.vue?vue&type=script&lang=js"
export * from "./SecondPart.vue?vue&type=script&lang=js"

import "./SecondPart.vue?vue&type=style&index=0&id=d2c80b4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c80b4e"]])

export default __exports__